export default __webpack_public_path__ + "static/media/select-game-right.e06a24d9.svg";